var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-button',{staticClass:"payment-card-add-button",attrs:{"loading":_vm.loading},on:{"click":function($event){return _vm.$emit('click')}}},[(!_vm.loading)?_c('i',{staticClass:"el-icon-add-card"}):_vm._e(),_vm._v(" "+_vm._s(_vm.$t('PAYMENT_CARD.ADD'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }